/*
  bf-cart-size.js
  Black Friday 2026 · taille dans le tiroir panier Moonbundle (app).

  Une piece BF a pour variante son palier de prix : le tiroir affiche donc "Black Friday price · 1"
  sous le nom, et pas la taille, qui est une propriete de ligne (Size). Le reglage Moonbundle
  "Afficher les proprietes de ligne" reste desactive : il s'appliquerait a tous les produits.

  Ici, sur les seules lignes qui ont une propriete Size, on affiche "Taille L" (ou "Taille unique")
  a la place du nom du palier. Les noeuds de l'app ne sont pas modifies : le texte d'origine est
  masque et le notre est pose par CSS (attribut data-bf-size), pour ne pas gener ses mises a jour.
  Les autres produits ne changent pas. Si l'app renomme ses classes, le tiroir retombe sur le nom
  du palier ; la taille reste dans la commande et s'affiche au paiement.
*/
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var DRAWER = '#moonbundle-cart-drawer';
  var ITEM = '.moonbundle-cart-item[data-item-key]';
  var OPTIONS = '.moonbundle-product-options-values';
  var FR = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase() === 'fr';
  var ONE_SIZE = 'One size';

  function label(size) {
    if (size === ONE_SIZE) return FR ? 'Taille unique' : 'One size';
    return (FR ? 'Taille ' : 'Size ') + size;
  }

  function addStyle() {
    if (document.getElementById('bf-cart-size-style')) return;
    var s = document.createElement('style');
    s.id = 'bf-cart-size-style';
    s.textContent =
      OPTIONS + '[data-bf-size]{font-size:0 !important;}' +
      OPTIONS + '[data-bf-size]::before{content:attr(data-bf-size);font-size:var(--bf-size-fs,12px);}';
    document.head.appendChild(s);
  }

  var timer = null, running = false, again = false;

  function apply() {
    var drawer = document.querySelector(DRAWER);
    if (!drawer) return;
    var lines = drawer.querySelectorAll(ITEM);
    if (!lines.length) return;
    if (running) { again = true; return; }
    running = true;
    fetch(ROOT + 'cart.js?bfs=' + Date.now(), { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sizes = {};
        (cart.items || []).forEach(function (it) {
          if (it.properties && it.properties.Size) sizes[it.key] = String(it.properties.Size);
        });
        Array.prototype.forEach.call(drawer.querySelectorAll(ITEM), function (line) {
          var opts = line.querySelector(OPTIONS);
          if (!opts) return;
          var size = sizes[line.getAttribute('data-item-key')];
          if (!size) {
            if (opts.hasAttribute('data-bf-size')) opts.removeAttribute('data-bf-size');
            return;
          }
          var text = label(size);
          if (opts.getAttribute('data-bf-size') === text) return;
          if (!opts.hasAttribute('data-bf-size')) {
            opts.style.setProperty('--bf-size-fs', window.getComputedStyle(opts).fontSize);
          }
          opts.setAttribute('data-bf-size', text);
        });
      })
      .catch(function () {})
      .then(function () {
        running = false;
        if (again) { again = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 120);
  }

  function watch() {
    var drawer = document.querySelector(DRAWER);
    if (!drawer) return false;
    addStyle();
    new MutationObserver(function (records) {
      /* Nos propres changements d'attribut ne relancent rien : seuls les ajouts de noeuds comptent */
      for (var i = 0; i < records.length; i++) {
        if (records[i].type === 'childList') { schedule(); return; }
      }
    }).observe(drawer, { childList: true, subtree: true });
    schedule();
    return true;
  }

  function init() {
    if (watch()) return;
    /* Le tiroir est injecte par l'app : on l'attend */
    var mo = new MutationObserver(function () {
      if (watch()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
